import { render, staticRenderFns } from "./nourishmentList.vue?vue&type=template&id=4e32f329&scoped=true"
import script from "./nourishmentList.vue?vue&type=script&lang=js"
export * from "./nourishmentList.vue?vue&type=script&lang=js"
import style0 from "./nourishmentList.vue?vue&type=style&index=0&id=4e32f329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32f329",
  null
  
)

export default component.exports